import styled from 'styled-components'

import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Wrapper = styled.div<{ $mode?: ThemeModeType }>`
    ul,
    ol {
        list-style-position: inside;
    }

    img {
        max-width: 100%;
    }

    blockquote {
        color: ${(props) => props.theme.color.g500};
        ${(props) => props.theme.fontWeight.medium}
        border-left: 4px solid ${(props) => props.theme.color.p500};
        padding-left: 24px;
    }

    em {
        font-style: italic;
    }

    //TODO : remove after strapi upgrade to 4
    ul li p,
    ol li p {
        display: inline;
    }

    strong {
        ${(props) => props.theme.fontWeight.bold}
    }

    a {
        color: ${(props) => props.theme.color.a500};
    }

    p + p {
        padding-top: 15px;
    }

    .highlight {
        ${(props) => props.theme.gradient.nector};
        background-clip: text;
        color: transparent;
    }

    table {
        width: 100%;
        border-spacing: 0;
        text-align: left;
        ${(props) => props.theme.boxShadow.level2};
        border-radius: 10px;
        @media ${(props) => props.theme.query.min.tablet} {
            overflow: hidden;
            table-layout: fixed;
        }
        @media ${(props) => props.theme.query.mobile} {
            display: block;
            overflow-x: auto;
            max-width: fit-content;
            margin: 0 auto;
        }
    }

    tr {
        &:last-child td {
            border-bottom: 0;
        }
    }

    th {
        ${(props) => props.theme.typo.bodyL}
        ${(props) => props.theme.fontWeight.medium};
        ${(props) =>
            props.$mode === 'Light'
                ? `
                        background-color: ${props.theme.color.p600};
                    `
                : `background-color: ${props.theme.color.p500};`};
        line-height: 180%;
        color: ${(props) => props.theme.color.white};
        padding: 10px 30px;
    }

    td {
        ${(props) => props.theme.typo.BodyM}
        ${(props) => props.theme.fontWeight.regular};
        line-height: 180%;
        color: ${(props) => props.theme.color.g600};
        padding: 16px;
        background-color: ${(props) => props.theme.color.white};
        border-bottom: 0.7px solid ${(props) => props.theme.color.g300};
    }
`
